module.exports = __webpack_public_path__ + "img/early-warning-disarm.f80c5bef.svg";